import { createContext, useContext } from 'react';
var RcFormContext = createContext(new Map());
var useRcFormContext = function () { return useContext(RcFormContext); };
export { RcFormContext, useRcFormContext };
